import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../Services/Account/EncryptionParams";

const RequestsManagerPage = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const RoleByUserGuid = useSelector((state) => state.RoleByUserGuid.RoleByUserGuid)
  const [RoleFinanceState, setRoleFinanceState] = useState(false);

  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  useEffect(() => {
    if (RoleByUserGuid?.includes(
      "ee74a1f0-bfdf-4ff3-bfc9-92d34ed9c41f"
    )) {
      setRoleFinanceState(true)
    }
    console.log(RoleByUserGuid, "RoleByUserGuid");

  }, [RoleByUserGuid]);

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicantsName",
      ShowStatus: true,
      NmaeColumn: "اسم المتقدم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "projectName",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicantTypeAr",
      ShowStatus: true,
      NmaeColumn: "نوع المستفيد",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantTypeAr",
        keyValueName: "applicantTypeAr",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusNameAr",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "statusNameAr",
        keyValueName: "appStatusId",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    {
      KeyName: "roundYearName",
      ShowStatus: false,
      NmaeColumn: "رقم الدورة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "roundYearName",
        keyValueName: "roundYearId",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    {
      KeyName: "flowName",
      ShowStatus: true,
      NmaeColumn: "اسم المرحلة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "flowName",
        keyValueName: "flowName",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        // setSecondarySectorsId(e.target.value);
        localStorage.setItem(
          "aI_ApplicationInformationId_Manager",
          e.target.value
        );
        navigate("/grants/manager/SingleTaskManager");
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: RoleByUserGuid?.includes(
        "ee74a1f0-bfdf-4ff3-bfc9-92d34ed9c41f"
      ) ? false : true,
    },
    {
      Click: async (e) => {
        let token = encryptToken(e.target.value);
        window.open(
          `/grants/manager/ApplicationInformation/` + token,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => { },
    componentBody: <div></div>,

    title: "القطاعات الثانوية التي تمثل المشروع",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "القطاعات الثانوية التي تمثل المشروع",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";

  return (
    <>
    {
      RoleByUserGuid?<>
        <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_ApplicationInformationId"}
        valueButtonAction={"aI_ApplicationInformationId"}
        URL={`api/WFApplication/GetAllApplicationInformation`}
        // UrlBody={{
        //   aI_ApplicationInformationId: localStorage.getItem(
        //     "aI_ApplicationInformationId"
        //   ),
        // }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={true}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
      </>:<></>
    }
    
    </>
  );
};

export default RequestsManagerPage;
